import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance } from 'vue';
import {
  ExpandableContent,
} from 'ui-shared-components';

import { useTravelInsuranceStore, type Traveller } from '@white-label-store/travel-insurance';
import { DATE_TIME_FORMATS, formatWithLocale } from '@white-label-helper/date-utilities';


export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-trip-details',
  props: {
    loading: { type: Boolean, default: false },
    expandedByDefault: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { loading: boolean, expandedByDefault: boolean };

const instance = getCurrentInstance();
const proxy = instance?.proxy as Vue;

const travelInsuranceStore = useTravelInsuranceStore();



const getDetails = () => {
  const startDate = travelInsuranceStore.form.travelDates?.startDate
    ? formatWithLocale(
        new Date(travelInsuranceStore.form.travelDates.startDate),
        DATE_TIME_FORMATS.day_month_year_no_comma, proxy.$i18n.locale
      )
    : '';
  const endDate = travelInsuranceStore.form.travelDates?.endDate
    ? formatWithLocale(
        new Date(travelInsuranceStore.form.travelDates.endDate),
        DATE_TIME_FORMATS.day_month_year_no_comma, proxy.$i18n.locale
      )
    : '';

  const dateOfBirthContent = travelInsuranceStore.form.travellers?.map((traveller: Traveller, index: number) => {
    const dateFormat = proxy.$i18n.locale === 'en-US'
      ? DATE_TIME_FORMATS.month_day_full_year_slash
      : DATE_TIME_FORMATS.day_month_full_year_slash;

    const dob = formatWithLocale(
      new Date(traveller.dateOfBirth),
      dateFormat, proxy.$i18n.locale
    );

    if (index === 0) {
      return `${proxy.$t('searchExtras.travelInsurance.modalTitle.step3')} - ${dob}`;
    } else {
      return `${proxy.$t('searchExtras.travelInsurance.additionalTraveller')} ${index + 1} - ${dob}`;
    }
  });

  return [
    {
      title: proxy.$t('searchExtras.travelInsurance.stepper.destination'),
      content: travelInsuranceStore.form.destination?.map((d: any) => d.name).join(', ') || '',
      class: 'destination',
    },
    {
      title: proxy.$t('searchExtras.travelInsurance.tripStart'),
      content: startDate,
      class: 'start-date',
    },
    {
      title: proxy.$t('searchExtras.travelInsurance.tripEnd'),
      content: endDate,
      class: 'end-date',
    },
    {
      title: proxy.$t('searchExtras.travelInsurance.countryOfResidenceLabel'),
      content: travelInsuranceStore.form.travellers?.[0]?.countryOfResidence?.name,
      class: 'country-of-residence',
    },
    {
      title: proxy.$t('searchExtras.travelInsurance.dateOfBirth'),
      content: dateOfBirthContent,
      class: 'date-of-birth',
    },
  ]
}

return { __sfc: true,instance, proxy, travelInsuranceStore, props, getDetails, ExpandableContent }
}

})